<script setup lang="ts">
import { TAB_BUTTON_POSITION, TAB_ICONS_NAMES } from '@/utils/tabs'
import { useTabStore } from '@/stores/tabs.store'
import arrowMaximize from '@/assets/images/ide/arrows-diagonal.svg'
import arrowRight from '@/assets/images/ide/arrow-narrow-right.svg'
import arrowBottom from '@/assets/images/ide/arrow-narrow-down.svg'

const props = defineProps({
  tabName: {
    type: String,
    required: false
  },
  currentPosition: {
    type: String,
    required: false
  }
})

const tabStore = useTabStore()

/**
 * Get the tab name
 * @param position set the tabs position
 * @returns tabName
 */
const getTabAnalyticsID = (position: TAB_BUTTON_POSITION) => {
  let id: string = ''
  switch (props.tabName) {
    case TAB_ICONS_NAMES.JDROID:
      id = 'jdroid'
      break
    case TAB_ICONS_NAMES.UPLOAD_FILES:
      id = 'upload-input-files'
      break
    case TAB_ICONS_NAMES.EXTERNAL_LIBRARIES:
      id = 'external-libraries'
      break
    case TAB_ICONS_NAMES.IO:
      id = 'input-output'
      break
    default:
      id = ''
      break
  }
  let pos: string = ''
  switch (position) {
    case TAB_BUTTON_POSITION.RIGHT:
      pos = 'move-right-ide'
      break
    case TAB_BUTTON_POSITION.BOTTOM:
      pos = 'move-bottom-ide'
      break
    case TAB_BUTTON_POSITION.MAXIMIZE:
      pos = 'maximize-ide'
      break
    default:
      pos = ''
      break
  }

  return `${id}-${pos}`
}
/**
 *
 * @param position set the tabs position
 */
const handleTabsPosition = (position: TAB_BUTTON_POSITION) => {
  //tabStore.setTabMaximized(!tabStore.isTabMaximized)
  tabStore.setTabSettings({ visible: false, position: props.currentPosition ?? '' })
  tabStore.setActiveTabPosition(position, (props.tabName as TAB_ICONS_NAMES) ?? '')
}
</script>

<template>
  <div
    v-on="$attrs"
    class="surface-secondary-base stroke-secondary-default inline-flex h-auto max-h-[116px] w-[158px] flex-col items-center justify-start rounded-[7px] border p-1.5 shadow"
  >
    <div
      v-if="props.currentPosition != TAB_BUTTON_POSITION.BOTTOM"
      @click="handleTabsPosition(TAB_BUTTON_POSITION.BOTTOM)"
      class="inline-flex w-[146px] cursor-pointer items-center justify-start gap-3 rounded p-1.5 hover:bg-new-neutral-100 dark:hover:bg-new-neutral-700/50"
    >
      <button
        :id="getTabAnalyticsID(TAB_BUTTON_POSITION.BOTTOM)"
        class="flex items-center justify-start gap-1 pr-2.5"
      >
        <img :src="arrowBottom" class="h-5 w-5" />
        <div class="text-xs font-normal leading-snug">Move Bottom</div>
      </button>
    </div>
    <div
      v-if="props.currentPosition != TAB_BUTTON_POSITION.RIGHT"
      @click="handleTabsPosition(TAB_BUTTON_POSITION.RIGHT)"
      class="inline-flex w-[146px] cursor-pointer items-center justify-start gap-3 rounded p-1.5 hover:bg-new-neutral-100 dark:hover:bg-new-neutral-700/50"
    >
      <button
        :id="getTabAnalyticsID(TAB_BUTTON_POSITION.RIGHT)"
        class="flex items-center justify-start gap-2.5 py-px pr-[11px]"
      >
        <img :src="arrowRight" class="h-5 w-5" />
        <div class="text-xs font-normal leading-snug">Move Right</div>
      </button>
    </div>
    <div
      v-if="props.currentPosition != TAB_BUTTON_POSITION.MAXIMIZE"
      @click="handleTabsPosition(TAB_BUTTON_POSITION.MAXIMIZE)"
      class="inline-flex w-[146px] cursor-pointer items-center justify-start gap-3 rounded p-1.5 hover:bg-new-neutral-100 dark:hover:bg-new-neutral-700/50"
    >
      <button
        :id="getTabAnalyticsID(TAB_BUTTON_POSITION.MAXIMIZE)"
        class="flex items-end justify-start gap-1 pr-[23px]"
      >
        <img :src="arrowMaximize" class="h-5 w-5" />
        <div class="text-xs font-normal leading-snug">Maximize</div>
      </button>
    </div>
  </div>
</template>
